import { projectRoute } from '@/core/helpers'

export default {
  CHANNEL_TYPES: {
    CHANNEL: '0',
    PREFERENCE: '1'
  },
  navigateToAuditLog(
    router,
    row,
    filterField = 'name',
    channelType,
    routeName = 'ConsentManagerAuditLog'
  ) {
    const filters = {}
    filters[filterField] = row[filterField]

    // Add type to filters when provided
    if (channelType !== undefined) {
      filters.type = channelType
    }

    router.push(
      projectRoute({
        name: routeName,
        query: {
          filters: JSON.stringify(filters)
        }
      })
    )
  },
  createViewLogsMixin({
    filterField = 'name',
    channelType,
    routeName = 'ConsentManagerAuditLog'
  } = {}) {
    return {
      methods: {
        viewLogs(row) {
          const filters = {}
          filters[filterField] = row[filterField]

          // Add type to filters when provided
          if (channelType !== undefined) {
            filters.type = channelType
          }

          this.$router.push(
            projectRoute({
              name: routeName,
              query: {
                filters: JSON.stringify(filters)
              }
            })
          )
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/consent-manager/utils/auditLogFilterUtils.js